<template>
  <div>
    <div class="report" v-if="showReport">
      <p class="mdl-typography--text-center">Da clic en alguna de las siguientes opciones para visualizar el <u>reporte de auditoría</u> al inmueble <strong>{{ audit.inmueble }}</strong></p>
      <p class="mdl-typography--text-center">
        <button class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored"
          @click="downloadReport">Descargar Reporte</button>
        <button class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored"
          @click="showReportOnScreen">Visualizar en Página</button>
      </p>
      <progress-bar v-show="showProgress"></progress-bar>
      <iframe id="iframeid" v-show="reportLoaded" :src="reportSrc" width="100%" height="100%"
        @load="showReportOnScreenEnd"></iframe>
    </div>

    <div class="incidences" v-else>
      <header>
        <div class="card-cover mdl-card mdl-shadow--2dp">
          <div class="mdl-card__media"
            :style="{ background: 'url(' + audit.cover + ') center / cover' }"></div>
          <div :class="['mdl-card__title', audit.promedio ? ( audit.promedio >= audit.aceptable ? 'bg-green' : ( audit.promedio > audit.inaceptable ? 'bg-yellow' : 'bg-red' )) : 'bg-grey']">
            <h2 class="mdl-card__title-text">
              <strong>{{ audit.inmueble }}</strong>
              <small>{{ audit.empresa }}</small>
            </h2>
          </div>
          <div :class="['mdl-card__title', audit.promedio ? ( audit.promedio >= audit.aceptable ? 'bg-green' : ( audit.promedio > audit.inaceptable ? 'bg-yellow' : 'bg-red' )) : 'bg-grey']">
            <!-- <div class="mdl-card__title-media">
              <img :src="audit.thumbnail">
            </div> -->
            <div class="mdl-card__helper">
              <strong>{{ audit.incidencias }}</strong>
              <small>Incidencias</small>
            </div>
            <div class="mdl-card__helper">
              <strong>{{ audit.promedio ? audit.promedio : 'N / A' }}</strong>
              <small>Puntos</small>
            </div>
            <div class="mdl-card__helper">
              <small>{{ audit.statusNombre.toUpperCase() }}</small>
            </div>
          </div>
          <div v-for="responsable in audit.mantenimiento" class="mdl-card__supporting-text">
            <div class="minilogo"
                  :style="{backgroundImage: 'url(' + responsable.avatar + ')' }"></div>
            <!-- <img class="avatar"
                  src=""
                  alt="Imagen del Encargado de Mantenimiento"> -->
            <div class="flex-grow-2">
              <strong>{{ responsable.nombre }}</strong>
              <span>Responsable de Mantenimiento</span>
            </div>
            <div>
              <!-- <span>{{ tree.inmueble.mantenimiento.since }}</span> -->
            </div>
          </div>
        </div>
      </header>
      <main>
        <div v-for="(incidencia, i) in incidencias" class="card-main mdl-card mdl-shadow--2dp">
          <div class="mdl-card__title">
            <h2 class="mdl-card__title-text">
              <strong>{{ incidencia.area }}</strong>
              <small>{{ incidencia.rubro }}</small>
            </h2>

            <!-- <div v-if="incidencia.aprobacion.status" class="mdl-card__helper">
              <span class="mdl-chip mdl-chip--colored">
                  <span class="mdl-chip__text">Aprobado</span>
              </span>
              <small>{{ incidencia.especificacion.toUpperCase() }}</small>
              <button type="button" :class="['current-chip', 'mdl-chip',
                'mdl-color--' + incidencia.color]"></button>
            </div> -->

            <div class="chips mdl-card__helper">
              <small>{{ incidencia.especificacion.toUpperCase() }}</small>
              <button type="button"
                :class="['current-chip', 'mdl-chip', 'mdl-color--' + incidencia.color]"
                @click="openChips"></button>
              <div class="mdl-chip__buttons" :data-i="i">
                <button v-for="(ponderacion, j) in incidencia.ponderaciones"
                  type="button"
                  :class="['mdl-chip', 'mdl-color--' + ponderacion.color]"
                  :data-id="ponderacion.id"
                  :data-color="ponderacion.color"
                  :data-value="ponderacion.valor"
                  @click="chipSelected"
                  :key="ponderacion.id"></button>
              </div>
            </div>
          </div>

          <div v-show="incidencia.color.match(/red|yellow/)" class="incidence mdl-grid">
            <div v-show="incidencia.update.imagenes.length === 0"
              class="mdl-cell mdl-cell--12-col">
              <p class="mdl-typography--text-center">
                Puedes agregar hasta 3 imágenes como evidencia fotográfica<br>
                para justificar tu calificación.
              </p>
            </div>
            <div v-show="incidencia.update.imagenes.length > 0"
              class="photos mdl-cell mdl-cell--12-col">
              <div class="mdl-card mdl-shadow--2dp"
                v-for="(imagen, k) in incidencia.update.imagenes"
                :style="{ background: 'url(' + imagen + ') center / cover' }"
                :key="k">
                <div class="mdl-card__title mdl-card--expand"></div>
                <div class="mdl-card__actions">
                  <span class="mdl-card__filename">
                    {{ 'Imagen #' + (k+1) + ' de la incidencia.' }}
                  </span>
                </div>
                <div class="mdl-card__menu" style="left: 16px;">
                  <button class="mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
                    :data-i="i" :data-k="k" @click="downloadPicture">
                    <i class="material-icons">file_download</i>
                  </button>
                </div>
                <div class="mdl-card__menu">
                  <button class="mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
                    :data-i="i" :data-k="k" @click="removePicture">
                    <i class="material-icons">delete</i>
                  </button>
                </div>
              </div>
            </div>
            <div class="mdl-cell mdl-cell--12-col mdl-typography--text-center">
              <button type="button" @click="uploadPhoto"
                class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored">
                Agregar Fotografía(s)
                <input type="file" accept="image/*" class="hidden"
                  :data-i="i"
                  @change="showPicture">
              </button>
              <button type="button" @click="showOldPictures" :data-i="i"
                class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored">
                Ver imágenes anteriores
              </button>
            </div>
            <div class="mdl-card__supporting-text">
              <div class="minilogo"
                :style="{backgroundImage: 'url(' + incidencia.avatar + ')' }"></div>
              <div class="supporting-text">
                <strong>Auditor</strong>
                <span>{{ incidencia.observaciones }}</span>
              </div>
            </div>

            <!-- <div v-if="!incidencia.aprobacion.status">

            </div> -->
            <div class="mdl-card__supporting-text">
                <div class="minilogo"
                  :style="{backgroundImage: 'url(' + incidencia.aprobacion.avatar + ')' }"></div>
                <div class="supporting-text">
                  <strong>Jefe de Auditor</strong>
                  <span>{{ incidencia.aprobacion.observaciones }}</span>
                </div>
              </div>
              <div class="comments mdl-cell mdl-cell--12-col">
                <img :src="$user.data.avatar || './img/profile-64.png'" class="avatar">
                <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                  <textarea class="mdl-textfield__input" type="text" rows= "3"
                    v-model="incidencia.update.observaciones"></textarea>
                  <label class="mdl-textfield__label">Escribe tus observaciones aquí...</label>
                </div>
              </div>
          </div>
        </div>
      </main>

      <footer v-show="incidencias.length > 0" class="footer">
        <div class="card-footer mdl-card mdl-shadow--2dp">
          <div class="mdl-card__title">
            <h4 class="mdl-card__title-text">Resumen de Auditoria</h4>
          </div>
          <div class="mdl-card__supporting-text">
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
              <textarea v-model="resumen" class="mdl-textfield__input" type="text" rows= "3"></textarea>
              <label class="mdl-textfield__label">Escribe el resumen de la auditoría aquí...</label>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import Progress from '@/components/Shared/Progress/'

export default {
  components: {
    'progress-bar': Progress
  },
  props: ['audit'],
  data () {
    return {
      title: 'Reporte de Auditoría',
      reportSrc: '',
      reportLoaded: false,
      incidencias: false,
      showReport: true,
      showProgress: false,
      points: 0,
      actionbar: {
        true: {
          show: true,
          buttons: [
            {
              text: 'Regresar',
              onclick: () => {
                this.$emit('showNewsfeed', true)
              }
            }
          ]
        },
        false: {
          show: true,
          buttons: [
            {
              text: 'Regresar',
              onclick: () => {
                this.showReport = !this.showReport
              }
            }
          ]
        }
      },
      observaciones: '',
      resumen: ''
    }
  },
  watch: {
    showReport () {
      this.$actionbar.init(this.actionbar[this.showReport])
    }
  },
  methods: {
    downloadReport () {
      window.open(this.$http.defaults.baseURL + '/auditoria/pdf/' +
        this.audit.id + '/' + this.$user.data.id)
    },
    showReportOnScreen () {
      if (this.reportSrc !== '') {
        document.getElementById('iframeid').src += ''
        this.reportLoaded = false
      }

      this.showProgress = true
      this.reportSrc = this.$http.defaults.baseURL + '/auditoria/pdf/' +
        this.audit.id + '/' + this.$user.data.id
    },
    showReportOnScreenEnd () {
      if (this.reportSrc === '') return
      this.showProgress = false
      this.reportLoaded = true
    },
    openChips (event) {
      let chipsContainer = event.target.parentNode.querySelector('.mdl-chip__buttons'),
          currentChip = chipsContainer.parentNode.querySelector('.current-chip')

      chipsContainer.classList.add('mdl-chip__buttons--opened')
      currentChip.setAttribute('hidden', true)
    },
    chipSelected (event) {
      let chipSelected = event.target,
          chipsContainer = chipSelected.parentNode,
          currentChip = chipsContainer.parentNode.querySelector('.current-chip'),
          content = currentChip.parentNode.parentNode,
          i = chipsContainer.dataset.i,
          incidencia = this.incidencias[i]

      incidencia.color = chipSelected.dataset.color
      incidencia.update.ponderacion_id = chipSelected.dataset.id
      chipsContainer.classList.remove('mdl-chip__buttons--opened')
      currentChip.removeAttribute('hidden')
    },
    uploadPhoto (event) {
      event.currentTarget.querySelector('input[type="file"]').click()
    },
    imageToDataUri (img, width, height, quality) {
      // create an off-screen canvas
      let canvas = document.createElement('canvas'),
          ctx = canvas.getContext('2d');

      // set its dimension to target size
      canvas.width = width;
      canvas.height = height;

      // draw source image into the off-screen canvas:
      ctx.drawImage(img, 0, 0, width, height);

      // encode image to data-uri with base64 version of compressed image
      return canvas.toDataURL('image/jpeg', quality);
    },
    showPicture (event) {
      // spinner.classList.remove('hidden');
      // selectPicture.disabled = true;
      // Get a reference to the taken picture or chosen file
      const self = this
      let fileInput = event.target,
          files = fileInput.files,
          file,
          fileSize,
          fileReader = new FileReader(),
          i = fileInput.dataset.i,
          incidencia = this.incidencias[i]

      if (incidencia.update.imagenes.length >= 3) {
        return this.$toast.show('Ha alcanzado el máximo de imágenes por incidencia.')
      }

      if (files && files.length > 0) {
        file = files[0]
        fileSize = file.size

        fileReader.onload = function (event) {
          let img = new Image(),
              newDataUri

          img.onload = (i) => {
            newDataUri = fileSize > 3000000
              ? self.imageToDataUri(img, img.width*0.25, img.height*0.25, 0.3)
              : newDataUri = self.imageToDataUri(img, img.width*0.5, img.height*0.5, 0.4)

            incidencia.update.imagenes.push(newDataUri)
          }

          img.src = fileReader.result
        }
        fileReader.readAsDataURL(file)
      } else {
        // Aqui la imagen se crea y luego te destruye.
        // spinner.classList.add('hidden');
        // selectPicture.disabled = false;
      }
    },
    showOldPictures (event) {
      let button = event.currentTarget,
          i = button.dataset.i,
          incidencia = this.incidencias[i],
          origen = incidencia.origen,
          container = document.createElement('div'),
          count = 0

      this.$loading.show()
      incidencia.imagenes.forEach(src => {
        let img = new Image()
        img.onload = () => {
          img.style.padding = '10px'
          container.appendChild(img)
          count += 1

          if (count === incidencia.imagenes.length) {
            this.$dialog.accept = () => {}
            this.$dialog.show('Imágenes Anteriores', container.outerHTML, true)
            this.$loading.hide()
          }
        }
        img.src = origen + src;
      })
    },
    downloadPicture (event) {
      let downloadButton = event.currentTarget,
          i = downloadButton.dataset.i,
          k = downloadButton.dataset.k,
          incidencia = this.incidencias[i],
          imagenes = incidencia.update.imagenes,
          anchor = document.createElement('a')
          // url = imagenes[k].replace(/^data:image\/[^;]+/, 'data:application/octet-stream'),
          // win = window.open(imagenes[k], '_blank')

      anchor.href = 'https://appauditoria.gtglobal.com/storage/auditorias/' + imagenes[k]
      anchor.target = '_blank'
      anchor.download = this.audit.inmueble + '__' +
        incidencia.area + '__' +
        incidencia.rubro + '__' +
        incidencia.especificacion + '__' +
        imagenes.length

      return anchor.click()


      // image.src = imagenes[k]

      // return win.document.write(image.outerHTML)
      // return window.open(imagenes[k], '_blank')
    },
    removePicture (event) {
      let deleteButton = event.currentTarget,
          i = deleteButton.dataset.i,
          k = deleteButton.dataset.k,
          incidencia = this.incidencias[i],
          imagenes = incidencia.update.imagenes

      return imagenes.splice(k, 1)
    }
  },
  mounted () {
    // console.log(this.audit)
    if (this.audit.statusId === 2) {
      const loadButton = {
        text: 'Ver Incidencias',
        onclick: () => {
          this.showReport = false
          this.$http.get('incidencias/' + this.audit.id)
            .then(response => {
              let data = response.data
              this.incidencias = data

              this.$emit('showProgress', false)
              setTimeout(() => {
                componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-textfield'))
              }, 200)
            })
          this.incidencias = []
          this.$emit('showProgress', true)
        }
      },
      sendButton = {
        text: 'Enviar Revaluación',
        onclick: () => {
          const incidences = document.querySelectorAll('.incidence')

          for (let i = 0; i < incidences.length; i++) {
            if (incidences[i].style.display !== 'none') {
              let textfield = incidences[i].querySelector('.mdl-textfield__input')
              let photos    = incidences[i].querySelector('.photos')

              if (textfield.value === '') {
                return this.$toast.show('Favor de escribir tus observaciones en cada incidencia.')
              } else if (photos.childElementCount === 0) {
                return this.$toast.show('Favor de asignar mínimo una fotografía en cada incidencia.')
              }
            }
          }

          if (this.resumen === '') {
            return this.$toast.show('Favor de escribir el resumen de la revaluación.')
          }

          this.$dialog.accept = () => {
            this.$loading.show()

            let incidenciasUpdated = []
            this.incidencias.forEach(incidencia => {
              incidenciasUpdated.push(incidencia.update)
            })

            this.$http.post('auditoria/revaluate/' + this.audit.id, {
              'auditoria_id': this.audit.id,
              'resumen': this.resumen,
              'incidencias': incidenciasUpdated
              }).then(response => {
                this.$loading.hide()
                if (response.data.status === 'OK') {
                  // enviar push notification a los jefes.
                  this.$http.post('auditoria/notify', {
                    type: 'reval-auditoria',
                    username: this.$user.data.name,
                    inmueble: this.audit.inmueble
                  }).then(response => {
                    console.log(response)
                  })

                  this.$emit('showNewsfeed', true)
                }
              }).catch(error => {
                this.$loading.hide()
                this.$toast.show('¡Algo sucedió! Porfavor, vuelve a intentarlo.')
              })
          }

          this.$dialog.show('Enviar Revaluación',
            'Estás a punto de enviar la revaluación de las incidencias, ¿deseas continuar?')
        }
      }

      this.actionbar.true.buttons.push(loadButton)
      this.actionbar.false.buttons.push(sendButton)
    }

    this.resumen = this.audit.resumen

    this.$endpoint.destroy()
    this.$actionbar.init(this.actionbar.true)
    this.$title.show(this.title + ': ' + this.audit.inmueble)

    componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-button'))
  }
}
</script>

<style lang="css" scoped>
  .report iframe {
    height: calc(100vh - 64px - 16px - 40px - 52px - 60px - 24px);
  }

  .incidences {
    width: 100%;
  }

  .incidences header {
    width: 100%;
    margin: 0;
  }

  .card-cover,
  .card-main {
    width: 100%;
    margin: 1rem 0;
    opacity: 1;
  }

  .card-cover .mdl-card__media {
    position: absolute;
    left: 0;
    width: 100%;
    height: 200px;
    background-position-y: 80%;
    -webkit-filter: blur(3px);
    -moz-filter: blur(3px);
    -o-filter: blur(3px);
    -ms-filter: blur(3px);
    filter: blur(3px);
    z-index: -1;
  }

  .card-cover .mdl-card__title {
    position: relative;
    height: auto;
    background: #bebebe
  }

  .card-cover .mdl-card__title * {
   color: #fff !important;
   opacity: 1;
  }

  .card-cover .mdl-card__title .mdl-card__title-media,
  .card-main .mdl-card__title .mdl-card__title-media {
    margin: 0 10px;
    align-self: flex-end;
  }

  .card-cover .mdl-card__title .mdl-card__title-media img {
    width: 80px;
  }

  .card-cover .mdl-card__title .mdl-card__title-text,
  .card-main .mdl-card__title .mdl-card__title-text {
    flex-grow: 2;
    margin-bottom: 10px;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .card-cover .mdl-card__title .mdl-card__title-text > span {
    font-size: 1.25rem;
  }

  .card-cover .mdl-card__title .mdl-card__helper {
    position: relative;
    bottom: -16px;
    flex-grow: 2;
    height: 70px;
    padding-top: 10px;
    margin: 0 10px;
    border-radius: 5px 5px 0 0;
    align-self: flex-end;
    text-align: center;
    line-height: 1.25;
    opacity: 0.85
  }

  .card-cover .mdl-card__title .mdl-card__helper:last-child {
    /*height: 45%;*/
  }

  .card-cover .mdl-card__title .mdl-card__helper strong {
    display: block;
    font-size: 1.5rem;
    font-weight: bolder;
  }

  .card-cover .mdl-card__title .mdl-card__helper small {
    font-size: 0.75rem;
    font-weight: bold;
    text-transform: uppercase;
  }

  .card-cover .mdl-card__supporting-text {
    width: 100%;
    height: auto;
    background: #fff;
    z-index: 1;

    box-sizing: border-box;
    padding: 16px;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }

  .card-cover .mdl-card__supporting-text > * {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .card-cover .mdl-card__supporting-text > *:first-child {
    margin-right: 16px;
  }

  .card-cover .mdl-card__supporting-text strong {
    font-weight: bold;
  }

  .card-cover .flex-grow-2 {
    flex-grow: 2;
  }

  .card-main {
    height: auto;
    min-height: auto;
  }

  .card-main .mdl-card__title {
    padding: 0.5rem 2rem;
  }

  .card-main .mdl-card__title .mdl-card__helper {
    display: flex;
  }

  .card-main .mdl-card__title .mdl-card__helper > small {
    padding: 8px;
  }

  .card-main .mdl-card__title .mdl-card__helper > button {
    width: 32px;
    cursor: pointer;
  }

  .card-main .mdl-card__media {
    display: flex;
    flex-wrap: wrap;
    background-color: #f3f3f3;
  }

  .card-main .mdl-card__media .mdl-card {
    width: 256px;
    height: 256px;
    margin: 5px auto;
    /*background: url('../assets/demos/image_card.jpg') center / cover;*/
    /*background-position: center;
    background-repeat: cover;*/
  }

  .card-main .mdl-card__media .mdl-card__actions {
    height: 52px;
    padding: 16px;
    background: rgba(0, 0, 0, 0.2);
  }

  .card-main .mdl-card__media .mdl-card__filename {
    color: #fff;
    font-size: 14px;
    font-weight: bold;
  }

  .card-main .mdl-card__supporting-text {
    display: flex;
  }

  .card-main .mdl-card__supporting-text .supporting-text {
    display: flex;
    flex-direction: column;
  }

  .chips .mdl-chip {
    width: 32px;
    cursor: pointer;
  }

  .chips .mdl-chip__buttons {
    display: none;
    /*position: absolute;
    top: 12px;
    right: 8px;*/
    padding: 0 6px;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14),
      0 3px 1px -2px rgba(0,0,0,.2),
      0 1px 5px 0 rgba(0,0,0,.12);
    border-radius: 20px;
    overflow: hidden;
  }

  .chips .mdl-chip__buttons--opened {
    display: block;
  }

  .chips .mdl-chip__buttons .mdl-chip {
    margin: 6px 2px;
  }

  .incidence {
    display: block;
    width: 100%;
    background-color: #f3f3f3;
  }

  .incidence h1 i {
    font-size: 6rem;
    color: rgb(148, 144, 148);
    opacity: 0.25;
  }

  .incidence .mdl-cell h1,
  .incidence .mdl-cell p {
    margin: 0;
  }

  .incidence .comments {
    display: flex;
    flex-direction: row;
    padding: 0 2rem;
  }

  .incidence .comments .avatar {
    width: 48px;
    height: 48px;
    margin: 10px;
    border-radius: 24px;
  }

  .incidence .comments .mdl-textfield {
    flex-grow: 2;
  }

  .photos {
    display: flex;
    flex-wrap: wrap;
  }

  .photos .mdl-card {
    width: 256px;
    height: 256px;
    margin: 5px auto;
    /*background: url('../assets/demos/image_card.jpg') center / cover;*/
    /*background-position: center;
    background-repeat: cover;*/
  }

  .photos .mdl-card__actions {
    height: 52px;
    padding: 16px;
    background: rgba(0, 0, 0, 0.2);
  }

  .photos .mdl-card__filename {
    color: #fff;
    font-size: 14px;
    font-weight: bold;
  }

  .photos .mdl-card__menu {
    color: #fff;
  }

  .card-footer {
    width: 100%;
    min-height: 120px;
  }

  .card-footer .mdl-card__title-text {
    font-size: 1.5rem;
  }

  .card-footer .mdl-card__supporting-text {
    width: 100%;
    padding: 0 16px;
  }

  .card-footer .mdl-card__supporting-text .mdl-textfield {
    width: inherit;
  }
</style>


// WEBPACK FOOTER //
// Report.vue?97741964